module.exports = __webpack_public_path__ + "img/HiddenExit-Gray.624fde9a.png";